import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex } from '@chakra-ui/react';
import { TState } from '../../redux/store';

const steps = [false, undefined, true];

const TripleSwitch = ({ onChange, value }: { onChange?: any; value?: any }) => {
  const theme = useSelector((state: TState) => state.theme);

  const [status, setStatus] = useState(value != null ? (value ? 2 : 0) : 1);

  useEffect(() => {
    onChange?.(steps[status]);
  }, [status]);

  const isFalse = status === 0;
  const isUndefined = status === 1;
  const isTrue = status === 2;

  return (
    <Box pr='12px'>
      <Flex
        height='20px'
        width='45px'
        borderRadius='25px'
        bgColor={isUndefined ? '#cbd5e0' : isFalse ? '#e53e3e' : theme.dark}
        position='relative'
        cursor='pointer'
        border='1px solid #cbd5e0'
      >
        <Box
          height='20px'
          width='15px'
          borderRadius='20px'
          onClick={() => setStatus(0)}
        />
        <Box
          height='20px'
          width='15px'
          borderRadius='20px'
          onClick={() => setStatus(1)}
        />
        <Box
          height='20px'
          width='15px'
          borderRadius='20px'
          onClick={() => setStatus(2)}
        />
        <Box
          boxSize='24px'
          border='1px solid #cbd5e0'
          bgColor='#ffffff'
          borderRadius='20px'
          position='absolute'
          top='-2px'
          left={isFalse ? '-8px' : isTrue ? '33px' : '10.5px'}
          transition='left .15s'
        />
      </Flex>
    </Box>
  );
};

export default TripleSwitch;
